import React from "react";
import "./styles.css";
import { DisabledPrompt, useStateManager } from "bcms-react";
import { SVGAsset } from "res";
import { LayoutContainer, RightColumnContainer, LeftColumnContainer } from "components/shared";
import { UICheckbox } from "components/ui";
import DateSelect from "components/custom-ui/DateSelect";

/**
 * @function MobileTemplateACHTable
 * @returns {React.Component}
 * @exported true
 * @description The mobile component for the table on the TemplatesACHPage.
 */
export default function MobileTemplateACHTable(props) {
  const templates = props.templates ?? [];
  const hasACHTemplates = templates.length > 0;
  const rows = templates.reduce((acc, item) => {
    acc.push(
      <MobileTemplateACHTableRow key={ item.id } template={ item } />
    );
    return acc;
  }, []);

  return (
    <div className="mobile-template-ach-table flex-container flex-vertical">
      <div className="flex-height column-header">
      <DisabledPrompt>
        <UICheckbox />
      </DisabledPrompt>
      </div>
      {/* No data for now, but these rows would be an array of components. */}
      { hasACHTemplates && rows }
      
      {/* only shown when there are is no data to show */}
      { !hasACHTemplates && 
      <MobileTemplateACHNoTableRows />
      }
    </div>
  );
}

/**
 * @function MobileTemplatesACHTableRow
 * @returns {React.Component}
 * @exported false
 * @description Table row used to display data in the MobileTemplateACHTable.
 */
function MobileTemplateACHTableRow(props) {
  const template = props.template ?? {};

  const numberOfParticipants = template.achToParticipants ? template.achToParticipants.length : 0;
  const setScheduleThisBatchLink =  numberOfParticipants > 0;

  return (
    <div className="mobile-template-ach-table-row">
      <LayoutContainer>
        <LeftColumnContainer>
          <div className="flex-container flex-horizontal align-center">
            <div className="set-width">
              <DisabledPrompt>
                <UICheckbox />
              </DisabledPrompt>
            </div>
            <div className="flex-width">
              <p><b>{ template.name }</b></p>
              <p>Credit Amount</p>
              <p>{ template.creditAmount.format() }</p>
              <p>Debit Amount</p>
              <p>{ template.debitAmount.format() }</p>
              <div className="effective-row">
                <p>Effective</p>
                <DateSelect value={ template.effectiveDate } />
                      {setScheduleThisBatchLink && 
                          <DisabledPrompt>
                          <a className="schedule-this-batch-link clickable" data-point={`Schedule This Batch_Link_${template.id}`}>Schedule This Batch</a>
                          </DisabledPrompt>
                        }
              </div>
              <div className="created-row">
                <p>Created</p>
                <p>{ template.createdDate.format("m/d/Y") }</p>
              </div>
            </div>
          </div>
        </LeftColumnContainer>
        <RightColumnContainer>
          <div className="flex-container flex-horizontal align-center">
          <div className="flex-width">
              <DisabledPrompt>
                <SVGAsset id="CopyIcon" className="clickable table-icon copy-icon" />
              </DisabledPrompt>
            </div>
            <div className="flex-width">
              <DisabledPrompt>
                <SVGAsset id="EditIcon" className="clickable table-icon edit-icon" />
              </DisabledPrompt>
            </div>
            <div className="flex-width">
              <DisabledPrompt>
                <SVGAsset id="TrashcanXIcon" className="clickable table-icon delete-icon" />
              </DisabledPrompt>
            </div>
          </div>
        </RightColumnContainer>
      </LayoutContainer>
    </div>
  );
}

/**
 * @function MobileTemplateACHNoTableRows
 * @returns {React.Component}
 * @exported false
 * @description The mobile table row that is shown in the MobileTemplateACHTable when there is no data to show.
 */
function MobileTemplateACHNoTableRows(props){
  return (
    <div className="mobile-template-ach-no-table-rows">
      <p className="text-center">There are no templates to display.</p>
    </div>
  );
}